<script lang="ts">
    import { getContext } from "svelte";
    import Page from "../components/Page.svelte";
    import { useLocation } from "../components/router/context";
    import Footer from "../components/Footer.svelte";

    const gigyaContext: any = getContext("gigya");
    const { navigate } = useLocation();

    $effect(() => {
        if (gigyaContext.ready) {
            gigya.accounts.showScreenSet({
                screenSet: 'Default-IdentifierFirst',
                containerID: 'gigya-screen',
                authMode: 'popup'
            });
        }
        
        if (gigyaContext.loggedIn) {
            navigate('/profile');
        }
    });

</script>
{#snippet footerSlot()}
    <Footer />
{/snippet}
<Page footer={footerSlot}>
    <article class="container m-auto flex flex-col items-center justify-center">
        <img src="/img/league-logo.png" alt="league logo" class="h-40 object-contain mb-8" />
        <div id="gigya-screen" class="w-full"></div>
    </article>
</Page>

<style>
</style>